import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @typescript-eslint/no-explicit-any,no-undefined */
import React from "react";
import classNames from "classnames";
import { defaultPropertiesOverride } from "../../constants";
import { getClassName, getTypeClassName, getCustomHeaderRenderer } from "../../utils";
export var TableHeader = function TableHeader(_ref) {
  var headerGroups = _ref.headerGroups,
      useDefaultColspan = _ref.useDefaultColspan,
      getHeaderProps = _ref.getHeaderProps,
      getColumnProps = _ref.getColumnProps;
  var rowClassName = getClassName({
    descendantName: "row",
    modifiers: "header"
  });
  var cellClassName = getClassName({
    descendantName: "cell",
    modifiers: "header"
  });

  var getHeaderCell = function getHeaderCell(header) {
    var Header = header.Header,
        accessor = header.accessor,
        type = header.type,
        style = header.style,
        className = header.className;

    var tableHeadProperties = _objectSpread({}, !useDefaultColspan && {
      colSpan: null
    });

    if (accessor) {
      tableHeadProperties.scope = "col";
    }

    var rendererHeader = function rendererHeader() {
      if (typeof Header === "function") {
        return header.render(getCustomHeaderRenderer(Header));
      }

      return header.render("Header");
    };

    return /*#__PURE__*/React.createElement("th", _extends({}, header.getHeaderProps([tableHeadProperties, (getColumnProps === null || getColumnProps === void 0 ? void 0 : getColumnProps(header)) || {}, (getHeaderProps === null || getHeaderProps === void 0 ? void 0 : getHeaderProps(header)) || {}]), {
      style: style,
      className: classNames(className, getTypeClassName(type), cellClassName)
    }), rendererHeader());
  };

  var getHeaderRow = function getHeaderRow(headerGroup) {
    var rowProps = headerGroup.getHeaderGroupProps([defaultPropertiesOverride]);
    return /*#__PURE__*/React.createElement("tr", _extends({}, rowProps, {
      className: rowClassName
    }), headerGroup.headers.map(getHeaderCell));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, headerGroups.map(getHeaderRow));
};